module.exports = __webpack_public_path__ + "static/media/INFLOW-fitness.b26e0162.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/videos/INFLOW-fitness.mp4
// module id = 187
// module chunks = 0